import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
// 다국어
import { useTranslation } from 'react-i18next';
// @mui
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

import ProfileComponent from './ProfileComponent';
// import Postcode from "./DaumPostcode";
import PasswordModalPopup from './PasswordModalPopup';
import PostcodeModalPopup from './DaumPostcode';

const StyledDiv = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '40px',
}));

const StyledDiv2 = styled('div')(() => ({
  backgroundColor: 'white',
  marginRight: '40px',
  padding: '30px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '10px',
  width: '20rem',
  height: '21rem',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
}));

const StyledDiv3 = styled('div')(() => ({
  backgroundColor: 'white',
  padding: '56px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  borderRadius: '10px',
}));

const StyledH2 = styled('h2')(() => ({
  marginBottom: '40px',
}));

const StyledTD = styled('td')(() => ({
  width: '200px',
  minWidth: '200px',
  height: '50px',
  fontWeight: 900,
}));

const StyledTD2 = styled('td')(() => ({
  width: '750px',
  height: 75,
}));

const StyledINPUT = styled('input')(() => ({
  width: 'inherit',
  height: 60,
  padding: '0px 10px',
  fontSize: 'large',
  border: '1px solid #ddd',
  borderRadius: '5px',
}));

const ProfileButton = styled(Button)(({ theme }) => ({
  padding: '15px 30px',
  backgroundColor: '#1a9ef8',
  borderRadius: '5px',
  fontSize: '1rem',
  color: 'white',
  fontWeight: '500',
  fontFamily: 'Pretendard-Regular',
  boxShadow: 'none',
}));

const postCodeStyle = {
  display: 'block',
  position: 'absolute',
  top: '50%',
  width: '400px',
  height: '500px',
  padding: '7px',
};

export default function SetProgile({ data }) {
  // 다국어
  const { t, i18n } = useTranslation(['page']);

  const UserData = JSON.parse(sessionStorage.getItem('login_info'));
  const userToken = JSON.parse(sessionStorage.getItem('login_info')).user_token;
  const [userProfile, setUserProfile] = useState([]);

  const [passwordModalOpen, setPasswordModalOpen] = React.useState(false);
  const [postcodeModalOpen, setPostcodeModalOpen] = React.useState(false);
  const [postcodeComplete, setPostcodeComplete] = React.useState(false);

  const [contact, setContact] = useState('');
  const [address, setAddress] = useState('');
  const [detailAddress, setDetailAddress] = useState('');
  const [zipCode, setZipCode] = useState('');

  const passwordHandleOpen = () => {
    setPasswordModalOpen(true);
  };
  const passwordHandleClose = () => {
    setPasswordModalOpen(false);
  };

  const postcodeHandleOpen = () => {
    setPostcodeComplete(false);
    setPostcodeModalOpen(true);
  };
  const postcodeHandleClose = () => {
    setPostcodeModalOpen(false);
  };

  // ---------------------------------------------------------

  // 회원정보 form

  const { register, handleSubmit } = useForm();
  const onSubmit = (data) => console.log(data);

  const handleDetailAddressChange = (event) => {
    setDetailAddress(event.target.value);
  };

  const handleContactChange = (e) => {
    setContact(e.target.value);
  };
  // ---------------------------------------------------------

  const handleSave = (event) => {
    if (window.confirm('이대로 저장 할까요?')) {
      // console.log("User token", inputUserId);
      const sendData = {
        user_token: userToken,
        address1: address,
        address2: detailAddress,
        address3: '',
        city: 3,
        zip_code: zipCode,
        contact,
      };

      console.log('sendData', sendData);
      axios({
        url: `${process.env.REACT_APP_SERVER_URL}/user/profile-address`,
        method: 'post',
        data: sendData,
      })
        .then((response) => {
          console.log('response', response.data[0][0].result);
          fetchData();
        })
        .catch((error) => {
          console.log('error', error);
        });
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_SERVER_URL}/user/profile/${userToken}`,
        method: 'post',
      });

      console.log('data', response.data[0][0]);
      setUserProfile(response.data[0][0]);
      if (response.data[0][0].contact != null) {
        setContact(response.data[0][0].contact);
        setAddress(response.data[0][0].address1);
        setDetailAddress(response.data[0][0].address2);
        setZipCode(response.data[0][0].zip_code);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useLayoutEffect(() => {
    fetchData();
  }, []);

  return (
    <div style={{ display: 'flex', padding: '0 10%' }}>
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <StyledDiv>
          <StyledDiv2>
            <ProfileComponent data={UserData} />
          </StyledDiv2>
          <StyledDiv3 style={{ flex: 1 }}>
            <StyledH2>{t('프로필 설정')}</StyledH2>
            <form name="revise_user_data" onSubmit={handleSubmit(onSubmit)}>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <StyledTD>{t('아이디(이메일)')}</StyledTD>
                      <StyledTD2>
                        <StyledINPUT defaultValue={UserData.login_id} disabled />
                      </StyledTD2>
                    </tr>
                    <tr>
                      <StyledTD>{t('이름')}</StyledTD>
                      <StyledTD2>
                        <StyledINPUT {...register('Name')} defaultValue={UserData.user_name} disabled />
                      </StyledTD2>
                    </tr>
                    <tr>
                      <StyledTD>{t('비밀번호')}</StyledTD>
                      <StyledTD2>
                        <ProfileButton variant="contained" onClick={passwordHandleOpen}>
                          {t('비밀번호 변경')}
                        </ProfileButton>
                      </StyledTD2>
                    </tr>
                    <tr>
                      <StyledTD>{t('연락처')}</StyledTD>
                      <StyledTD2>
                        <StyledINPUT
                          {...register('contact')}
                          defaultValue={contact}
                          onChange={handleContactChange}
                          placeholder={t('연락처')}
                        />
                      </StyledTD2>
                    </tr>
                    <tr>
                      <StyledTD style={{ verticalAlign: 'top' }}>{t('주소')}</StyledTD>
                      <StyledTD2>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            height: 200,
                          }}
                        >
                          <div>
                            <StyledINPUT {...register('zipCode')} defaultValue={zipCode} placeholder={t('우편번호')} />
                            {/* <Postcode>우편번호 검색</Postcode> */}
                            {/* <ProfileButton variant="contained" style={{marginLeft:'10px'}} onClick={postcodeHandleOpen}>우편번호 검색</ProfileButton> */}
                            <PostcodeModalPopup setAddress={setAddress} setZipCode={setZipCode} />
                          </div>
                          <StyledINPUT {...register('address1')} defaultValue={address} placeholder={t('주소')} />
                          <StyledINPUT
                            {...register('detailAddress')}
                            defaultValue={detailAddress}
                            onChange={handleDetailAddressChange}
                            placeholder={t('상세주소')}
                          />
                        </div>
                      </StyledTD2>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
                <ProfileButton variant="contained" onClick={handleSave}>
                  {t('회원정보 변경')}
                </ProfileButton>
              </div>
            </form>
          </StyledDiv3>
        </StyledDiv>
      </div>

      <PasswordModalPopup modalOpen={passwordModalOpen} handleClose={passwordHandleClose} />

      {/* {(postcodeModalOpen || postcodeComplete) && <PostcodeModalPopup modalOpen={postcodeModalOpen} address={address} setAddress={setAddress} setZipCode={setZipCode}  setPostcodeComplete={setPostcodeComplete} /> } */}
    </div>
  );
}
